module.exports = __webpack_public_path__ + "media/brands/haotian-181899ab.png";